module.exports = __webpack_public_path__ + "images/6528547f8322e9cf64458725f0a72827.svg";